
import ClientNavbar from ".";

const PeregrinClientNavbar = () => {
  return <ClientNavbar hideCartButton />;
};

export default PeregrinClientNavbar;
